import { Component, EventEmitter, Input, Output } from "@angular/core";
import { GroupAddressWithExtensions } from "@onsip/web/features/administrators/groups/groupsPage/groups-page.component";
import { E2eLocators } from "@onsip/e2e/configs/locators";

@Component({
  selector: "onsip-group-shelf-members-view",
  templateUrl: "./group-shelf-members-view.component.html",
  styleUrls: ["./group-shelf-members-view.component.scss"],
  standalone: false
})
export class GroupShelfMembersViewComponent {
  constructor() {}
  @Output() editPanel = new EventEmitter<void>();
  @Input() group!: GroupAddressWithExtensions;
  E2eLocators = E2eLocators;
}
